import {createAction, props} from '@ngrx/store';
import {ClusterInstanceTypeRecord} from '../../../services/api/vocabulary/cluster/instance-types/cluster.instance-type.vocabulary.model';

export const loadAllInstanceTypes = createAction(
  '[AllInstanceTypes] Load All Instance Types'
);

export const loadAllInstanceTypesSuccess = createAction(
  '[AllInstanceTypes] Load All Instance Types Success',
  props<{ data: ClusterInstanceTypeRecord[] }>()
);

export const loadAllInstanceTypesFailure = createAction(
  '[AllInstanceTypes] Load All Instance Types Failure',
  props<{ error: unknown }>()
);

export const clearAllInstanceTypesState = createAction(
  '[AllInstanceTypes] clear All Instance Types State'
);
